import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../app.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { AddQuestionInducComponent } from './add-question-induc/add-question-induc.component';
import { AnswerSetupInductionQuestionComponent } from './answer-setup-induction-question/answer-setup-induction-question.component';
import { AddInductionQuestionComponent } from './component/add-induction-question/add-induction-question.component';
import { EditSetupInductionQuestionComponent } from './edit-setup-induction-question/edit-setup-induction-question.component';
import { InductionQuestionsListVM } from './setup-induction-question';

@Component({
  selector: 'app-setup-induction-question',
  templateUrl: './setup-induction-question.component.html',
  styleUrls: ['./setup-induction-question.component.css']
})
export class SetupInductionQuestionComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private _appService: AppService,
    private _inductionService: SafetyInductionService,
  ) { }

  loading: boolean = false;
  SetupInductionQuestion: InductionQuestionsListVM;
  selectedCategory: number = 1;

  ngOnInit() {
    this._appService.setPageTitle('Setup Induction Questions');
   // this._appService.setPageSubTitle('');

    this.SetupQuestions(this.selectedCategory)

  }

  changeInductionCategory(ID) {
    this.SetupQuestions(ID)
  }

  SetupQuestions(ID: number) {
    this.loading = true
    this._inductionService.SetupQuestions(ID).subscribe(res => {

      if (res.m_Item1) {


        let data: InductionQuestionsListVM;
        data = res.m_Item2
        data.Selections.map(s => {
          let ques_ = data.Questions.filter(f => f.SlideSelectionId == s.ID)
          s.Questions = ques_

        })
        console.log("SetupQuestions", data)
        this.SetupInductionQuestion = data;
      }
      // this.categories=res.InductionTypes;
      //this.questions=res.Selections;
      this.loading = false
    })
  }

  openAddQuestionDialog(section) {
    //AddInductionQuestionComponent
    //EditSetupInductionQuestionComponent
    const dialogRef = this.dialog.open(AddInductionQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',
      data: {
        QuestionsTypes: this.SetupInductionQuestion.QuestionsTypes,
        inductionSlides: this.SetupInductionQuestion.Slides,
        SlideSelectionId: section.ID,
        SectionId: section.ID
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.SetupQuestions(this.selectedCategory)
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

  clickQuestionenableDisable(question) {
    let val = question.Active == true ? false : true
    this._inductionService.ToggleInductionQuestion(question.Id, val).subscribe(res => {
      console.log("ToggleInductionQuestion", res)
      if (res.m_Item1) {
        this.SetupQuestions(this.selectedCategory)
      }
      // this.categories=res.InductionTypes;
      //this.questions=res.Selections;
    })
  }

  onClickSetupQuestionAnswer(question) {
    const dialogRef = this.dialog.open(AnswerSetupInductionQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',
      data: {
        Question: question,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.SetupQuestions(this.selectedCategory)
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }



  onClickEditQuestion(question) {
    const dialogRef = this.dialog.open(AddInductionQuestionComponent, {
      disableClose: true,
      panelClass: 'removeModalOverflow',
      minWidth: '800px',
      minHeight: '500px',

      data: {
        QuestionsTypes: this.SetupInductionQuestion.QuestionsTypes,
        inductionSlides: this.SetupInductionQuestion.Slides,
        // SectionId:section.ID,
        Question: question.Question,
        QuestionId: question.Id,
        QuestionTypeId: question.QuestionTypeId,
        SlideSelectionId: question.SlideSelectionId,
        SlideID: question.InductionSlideId,
        edit: true
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.SetupQuestions(this.selectedCategory)
      } else if (result == false) {

        console.log('The dialog was closed');
      }
    });
  }

}
